"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighbondError = void 0;
class HighbondError extends Error {
    constructor(arg1, arg2, arg3) {
        let debugInfo = typeof arg1 === 'string' ? arg1 : '';
        let error = arg1 instanceof Error ? arg1 : arg2 instanceof Error ? arg2 : undefined;
        let message = typeof arg2 === 'string' ? arg2 : arg3 || '';
        super(message);
        this.name = this.constructor.name; // This can only be set after super is called. But the stack will have the correct name as long as it's set before the stack is actually accessed.
        let errorCleansedStack = error instanceof HighbondError ? error.cleansedStack : error === null || error === void 0 ? void 0 : error.stack.replace(error.message, '');
        this.cleansedStack = errorCleansedStack ? `${this.stack}\nCaused By: ${errorCleansedStack}` : this.stack;
        let fullMessage = (message ? `${message} ` : '') + (debugInfo ? `(${debugInfo})` : '');
        let stackObj = { name: this.name, message: fullMessage };
        Error.captureStackTrace(stackObj, this.constructor);
        this.stack = error ? `${stackObj.stack}\nCaused By: ${error.stack}` : stackObj.stack;
    }
    static from(error) {
        if (error instanceof HighbondError) {
            return error;
        }
        let message = error.expose ? error.message : '';
        let highbondError = new HighbondError('', message);
        highbondError.name = error.name;
        highbondError.stack = error.stack;
        highbondError.cleansedStack = error.expose ? error.stack : error.stack.replace(error.message, '');
        return highbondError;
    }
}
exports.HighbondError = HighbondError;
//# sourceMappingURL=HighbondError.js.map